import apiFetch from '../apiFetch'

export default function (token, fieldTypeId) {
  return apiFetch({ endPoint: `template/fields?fieldTypeId=${fieldTypeId}`, method: 'GET', token: token })
}
